import { createSlice } from '@reduxjs/toolkit';
import { clearPlantItemRenewalForm } from 'plantItemNew/redux/slices/formSlice';
import { getApplication } from 'shared/redux/applicationSlice';

const initialState = {
  emailAddress: '',
  changeEmail: '',
  newEmailAddress: '',
  fullName: '',
  jobTitle: '',
  phoneNumber: {},
};

const plantItemRenewalApplicantDetailsSlice = createSlice({
  name: 'plantItemRenewalApplicantDetails',
  initialState,
  reducers: {
    storePlantItemRenewalApplicantFullName(state, action) {
      state.fullName = action.payload;
    },
    storePlantItemRenewalApplicantJobTitle(state, action) {
      state.jobTitle = action.payload;
    },
    storePlantItemRenewalApplicantContactDetails(state, action) {
      state.emailAddress = action.payload.emailAddress;
      state.changeEmail = action.payload.changeEmail;
      state.newEmailAddress = action.payload.newEmailAddress;
      state.phoneNumber = action.payload.phoneNumber;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(clearPlantItemRenewalForm, () => {
        return initialState;
      })
      .addCase(getApplication.fulfilled, (state, action) => {
        return { ...action.payload.applicationData.plantItemRenewalApplicantDetails };
      });
  },
});

export const {
  storePlantItemRenewalApplicantFullName,
  storePlantItemRenewalApplicantJobTitle,
  storePlantItemRenewalApplicantContactDetails,
} = plantItemRenewalApplicantDetailsSlice.actions;
export const plantItemRenewalApplicantDetailsReducer = plantItemRenewalApplicantDetailsSlice.reducer;
